import config from '@/config';
import provider from '@/helpers/provider';
import abi from '../../../abi';
import { multicall } from '@/helpers/utils';
import { fetchUserBalance } from '@/helpers';

const state = {
  balances: {}
};

const actions = {
  async fetchBalances({ commit, rootState }: any) {
    if (!rootState.auth.address) {
      return;
    }

    const supportCurrencies = config.supportCurrencies;
    const myAddress = rootState.auth.address;

    try {
      const calls: any = [];
      supportCurrencies.forEach((supportCurrency: any) => {
        calls.push({
          address: supportCurrency.address,
          name: 'balanceOf',
          params: [myAddress]
        });
      });
      const res = await multicall(provider, abi['ERC20'], calls);

      res.forEach((item: any, index: any) => {
        const supportCurrency = supportCurrencies[index];
        const [balance] = item;
        commit('setBalance', {
          currency: supportCurrency.address,
          balance: balance.toString()
        });
      });
    } catch (e) {
      console.error('connect ', e);
    }
  },
  async fetchBalance({ commit, rootState }: any, currency: any) {
    if (!rootState.auth.address) {
      return;
    }
    const myAddress = rootState.auth.address;
    const balance = await fetchUserBalance(currency, myAddress);
    commit('setBalance', {
      currency,
      balance: balance.toString()
    });
  }
};
const mutations = {
  setBalance(state: any, { currency, balance }: any) {
    state.balances[currency] = balance;
  },
  setBalances(state: any, balances: any) {
    state.balances = balances;
  }
};

const getters = {
  myBuniBalance(state: any) {
    return state.balances[config.addresses.buniAddress];
  },
  myBalances(state: any) {
    return state.balances;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
